export default "__VITE_ASSET__BvkMbGLT__"